import React, { useState } from 'react';
import Logo from '../Assests/logo-light.png';
import { NavLink, Outlet } from 'react-router-dom';
import '../style/landing.css';
import { Icon, Icons } from '../Components/Icon';
import MobileMenu from './SidebarLayout/MobileMenu';
import CalendlyBooking from '../Components/calendly/Calendly';

export default function LandingLayout() {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [activeCalendly, setActiveCalendly] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <div>
        {/* Navbar Start */}
        <header className="text-sm font-medium navbar-landing nav-dark-landing font-inter">
          <div className="container bg-white">
            <nav>
              {/* Navbar Brand Logo */}
              <a href="/" className="logo">
                <img src={Logo} className="w-40 h-8 logo-dark" alt="Paytton" />
              </a>
              <div
                role="button"
                tabIndex={0}
                className="lg:hidden flex items-center ms-auto px-2.5"
                onClick={() => setShowMobileMenu((prevState) => !prevState)}
              >
                <button
                  className="inline-flex items-center justify-center w-12 hs-collapse-toggle h-9"
                  type="button"
                >
                  <Icon name={Icons.Menu} />
                </button>
              </div>

              {/* Nevigation Menu */}
              <div className="items-center justify-center hidden mx-auto mt-2 overflow-hidden transition-all duration-300 hs-collapse lg:basis-auto basis-full grow lg:flex lg:mt-0">
                <ul className="navbar-landing-nav">
                  {/* Home Page Link */}
                  <li className="nav-item">
                    <a className="nav-link" href="#about">
                      About
                    </a>
                  </li>
                  {/* Features Page Link */}
                  <li className="nav-item">
                    <a className="nav-link" href="#feature">
                      Features
                    </a>
                  </li>
                  {/* Pricing Page Link */}
                  <li className="nav-item">
                    <a className="nav-link" href="#pricing">
                      Pricing
                    </a>
                  </li>
                  {/* Faq Page Link */}
                  <li className="nav-item">
                    <a className="nav-link" href="#faq">
                      Faq
                    </a>
                  </li>
                </ul>
              </div>

              {/* Download Button */}
              <div className="relative items-center hidden gap-5 lg:flex">
                <div className="nav-btn bg-transparent text-[red] px-4">
                  <button
                    onClick={() => {
                      setIsLoading(true);
                      setActiveCalendly(!activeCalendly);
                    }}
                    className="flex items-center gap-2 rounded-[9.79px] relative z-50 cursor-pointer px-4 text-base font-medium p-2.5 bg-transparent border border-red-700 text-red-600"
                  >
                    <span>{activeCalendly ? 'Close' : 'Book a demo'} </span>
                    {isLoading && activeCalendly && (
                      <span>
                        {' '}
                        <svg
                          aria-hidden="true"
                          className="w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span className="sr-only">Loading...</span>
                      </span>
                    )}
                  </button>
                  {activeCalendly && (
                    <div className="fixed w-full h-[600px] z-10 top-[70px] right-0 transform  max-[850px]:left-[0%] max-[850px]:bottom-[-240px] max-[620px]:left-[-150px] max-[600px]:w-[380px] max-[450px]:w-[320px] max-[320px]:w-[220px]">
                      {<CalendlyBooking setIsLoading={setIsLoading} width={400} />}
                    </div>
                  )}
                </div>
                <NavLink
                  to="/auth/login"
                  className="nav-btn bg-[#061A40] text-white w-24"
                >
                  Sign in
                </NavLink>
              </div>
            </nav>
            {/* end nav */}
            {/* Mobile Navigation Menu */}
            {showMobileMenu && <MobileMenu toggleMenu={setShowMobileMenu} />}
          </div>
        </header>
        {/* Navbar End */}
      </div>
      <div className="relative pt-20 overflow-hidden lg:pt-16 active">
        <Outlet />
      </div>
    </>
  );
}
